(() => {
  const closeAccordion = (detailsEl) => {
    if (detailsEl && detailsEl.open) detailsEl.open = false;
  };

  const updateSummaryText = (detailsEl) => {
    const summary = detailsEl?.querySelector('summary');
    if (!summary) return;

    // Busca selects dentro del acordeón (Dawn usa selects o radios según configuración)
    const selects = detailsEl.querySelectorAll('select');
    const checkedRadios = detailsEl.querySelectorAll('input[type="radio"]:checked');

    const values = [];

    selects.forEach((s) => {
      if (s.value) values.push(s.value);
    });

    checkedRadios.forEach((r) => {
      if (r.value) values.push(r.value);
    });

    // Si hay algo seleccionado, lo mostramos (si no, dejamos el texto original)
    const baseText = summary.getAttribute('data-base-text') || summary.textContent.trim();
    summary.setAttribute('data-base-text', baseText);

    if (values.length) {
      summary.textContent = values.join(' · ');
    } else {
      summary.textContent = baseText;
    }
  };

  const init = () => {
    document.querySelectorAll('details[data-variant-accordion]').forEach((detailsEl) => {
      // Al cambiar opción: actualizar texto y cerrar
      detailsEl.addEventListener('change', (e) => {
        // Solo si el cambio viene de un input/select dentro del acordeón
        if (!(e.target instanceof HTMLInputElement || e.target instanceof HTMLSelectElement)) return;

        updateSummaryText(detailsEl);

        // Pequeño delay para que Dawn termine de procesar el cambio de variante
        setTimeout(() => closeAccordion(detailsEl), 150);
      });

      // Inicializar texto al cargar
      updateSummaryText(detailsEl);
    });
  };

  // Shopify editor / cambios dinámicos
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
